import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editGroupDefault",
  tabindex: "-1",
  "aria-labelledby": "editGroupDefault",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroupDefault"
}
const _hoisted_6 = { class: "row mx-5 mt-4 px-0 pb-4 gx-3 mb-4 justify-content-lg-center" }
const _hoisted_7 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_8 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_9 = { class: "col-lg-7" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "row mx-5 px-0 gx-3 justify-content-lg-center" }
const _hoisted_13 = { class: "w-max-content col-lg-5 col-form-label" }
const _hoisted_14 = { class: "col-lg-7 mb-5" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_18 = {
  class: "modal fade",
  id: "confirmModalDefault",
  tabindex: "-1",
  "aria-labelledby": "confirmModalDefault",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-lg" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModalDefault"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "row mb-5 px-3" }
const _hoisted_26 = { class: "col-lg-4" }
const _hoisted_27 = { class: "col-lg-8" }
const _hoisted_28 = { class: "row mb-5 px-3" }
const _hoisted_29 = { class: "col-lg-4" }
const _hoisted_30 = { class: "col-lg-8" }
const _hoisted_31 = { class: "text-break break-spaces" }
const _hoisted_32 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_33 = {
  class: "modal fade",
  id: "editGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "editGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModal"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "text-center my-4" }
const _hoisted_41 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { computed, ref, watchEffect, onMounted, nextTick } from 'vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE, ROOT_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { useRouter } from 'vue-router'
import { customMaxLength, scrollToErrors } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupId: String,
},
  setup(__props) {

const props = __props

const editFailed = ref<boolean>(false)
const store = useStore()
const loadingEdit = ref<boolean>(false)
const modalEdit = ref()
const modalEditConfirm = ref()
const modalEditFinish = ref()
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const router = useRouter()

onMounted(() => {
  modalEdit.value = new Modal(document.getElementById('editGroupDefault'))
  modalEditConfirm.value = new Modal(document.getElementById('confirmModalDefault'))
  modalEditFinish.value = new Modal(document.getElementById('editGroupSuccess'))
})
const rules = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
  }
})

const formData = ref({
  name: '',
  information: '',
})
const dataDefault = ref({})

watchEffect(async () => {
  if (props.groupId) {
    try {
      const response = await groupsService.getDetailGroupApi(props.groupId)
      if (response?.status === 200) {
        formData.value = {
          name: response?.data?.data?.group?.name,
          information: response?.data?.data?.group?.information,
        }
        dataDefault.value = {
          name: response?.data?.data?.group?.name,
          information: response?.data?.data?.group?.information,
        }
      } else if (response?.response?.status === 404) {
        router.push('/404')
      }
    } catch (error) {
      console.log(error)
    }
  }
})

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#editGroupDefault')
    })
    return
  }
  modalEdit.value.hide()
  modalEditConfirm.value.show()
}

const editGroup = async () => {
  loadingEdit.value = true
  try {
    const response = await groupsService.editGroupApi(props.groupId, formData.value)
    if (response?.status === 200) {
      editFailed.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.EDIT_GROUPS, response?.data?.data?.group)
      dataDefault.value = formData.value
    } else {
      editFailed.value = true
    }
    // 2022/09/12 TienNV Fix double click button confirm edit group
    modalEditConfirm.value?.hide()
    modalEditFinish.value?.show()
    loadingEdit.value = false
  } catch (error) {
    modalEditConfirm.value?.hide()
    modalEditFinish.value?.show()
    loadingEdit.value = false
    console.log(error)
    editFailed.value = true
  }
}
const resetData = async () => {
  formData.value = {
    name: dataDefault.value?.name,
    information: dataDefault.value?.information,
  }
  ngKeyName.value = false
  ngKeyInfo.value = false
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                  placeholder: _unref(translate)('placeholder')
                }, null, 42, _hoisted_10), [
                  [
                    _vModelText,
                    _unref(v$).name.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyName.value && !_unref(v$).name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('groupName'),
                  validator: _unref(v$).name.$errors[0]?.$validator,
                  params: [1, 30]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('groupDes')), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "information",
                  class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                  placeholder: _unref(translate)('placeholder'),
                  rows: "4"
                }, null, 42, _hoisted_15), [
                  [
                    _vModelText,
                    _unref(v$).information.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyInfo.value && !_unref(v$).information.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('groupDes'),
                  validator: _unref(v$).information.$errors[0]?.$validator,
                  params: [200]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    onClick: resetData,
                    class: "me-lg-3",
                    "data-bs-dismiss": "modal",
                    className: 'fw-bold'
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                className: 'fw-bold'
              }, null, 8, ["title"]),
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    onClick: resetData,
                    class: "me-lg-3",
                    "data-bs-dismiss": "modal",
                    className: 'fw-bold'
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h5", _hoisted_22, _toDisplayString(_unref(translate)('groupEditting')), 1),
              _hoisted_23
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(translate)('groupName')), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(formData.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(translate)('groupDes')), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", _hoisted_31, _toDisplayString(formData.value.information), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    title: _unref(translate)('update'),
                    type: 'secondary',
                    loading: loadingEdit.value,
                    onClick: editGroup,
                    className: 'fw-bold',
                    disabled: loadingEdit.value
                  }, null, 8, ["title", "loading", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#editGroupDefault',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    title: _unref(translate)('update'),
                    type: 'secondary',
                    loading: loadingEdit.value,
                    onClick: editGroup,
                    className: 'fw-bold',
                    disabled: loadingEdit.value
                  }, null, 8, ["title", "loading", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h5", _hoisted_37, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _hoisted_38
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", _hoisted_40, _toDisplayString(editFailed.value ? _unref(translate)('SN20EditGroupError') : _unref(translate)('updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})